import React, { useState } from 'react';
import { Panel, PanelBody, PanelHeader } from '../../../util/panel';
import { Table } from 'antd';
import usePaginationHook from '../../../../utils/usePagination';
import dayjs from 'dayjs';
import fitCheckingServices from '../../../../services/fit-checking.services';
import 'dayjs/locale/th';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { RiFileListLine } from 'react-icons/ri';
import BranchActivityListModal from '../components/modal/BranchActivityListModal';

dayjs.locale('th');

const pageSize = 10;

const CheckInBranchPage = () => {
  const history = useHistory();
  const [branchId, setBranchId] = useState(undefined);
  const [activityListOpen, setActivityListOpen] = useState(false);
  const {
    data: branchLists,
    setData,
    page,
    setPage,
    total,
    setTotal,
  } = usePaginationHook();

  fitCheckingServices.useQueryGetBranches({ take: pageSize, page }, (data) => {
    setData(data.data);
    setTotal(data.meta.total);
  });

  const columns = [
    {
      title: 'NO',
      dataIndex: 'index',
      key: 'index',
      render: (_, _record, index) => (
        <span>{(page - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      title: 'รูปสาขา',
      dataIndex: 'ImgUrl',
      key: 'ImgUrl',
      render: (_, record) => (
        <div style={{ width: 60, height: 60 }}>
          {record.branchData?.ImgUrl && (
            <img
              alt={record.branchData?.Name}
              src={record.branchData.ImgUrl}
              style={{
                width: 60,
                height: 60,
                objectFit: 'cover',
                borderRadius: 100,
              }}
            />
          )}
        </div>
      ),
    },
    {
      title: 'ชื่อสาขา',
      dataIndex: 'Name',
      key: 'Name',
      render: (_, record) => <span>{record.branchData?.Name || '-'}</span>,
    },
    {
      title: 'สร้างเมื่อ',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (_, record) => (
        <span>
          {record.createdAt
            ? dayjs(record.createdAt).format('DD/MMM/YYYY เวลา HH:mm')
            : '-'}
        </span>
      ),
      sorter: (a, b) =>
        dayjs(a.createdAt).diff(dayjs(b.createdAt), 'D') > 0 ? 1 : -1,
    },
    {
      title: 'อัปเดตเมื่อ',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (_, record) => (
        <span>
          {record.updatedAt
            ? dayjs(record.updatedAt).format('DD/MMM/YYYY เวลา HH:mm')
            : '-'}
        </span>
      ),
      sorter: (a, b) =>
        dayjs(a.updatedAt).diff(dayjs(b.updatedAt), 'D') > 0 ? 1 : -1,
    },
    {
      title: '',
      key: 'action',
      render: (_, record) => (
        <div
          style={{ display: 'flex', justifyContent: 'flex-end' }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div
            style={{ cursor: 'pointer', marginLeft: 10 }}
            onClick={() => {
              setBranchId(record.id);
              setActivityListOpen(true);
            }}
          >
            <RiFileListLine />
          </div>
        </div>
      ),
    },
  ];

  return (
    <Panel>
      <PanelHeader>เช็คอินที่สาขา</PanelHeader>
      <PanelBody>
        <Table
          columns={columns}
          dataSource={branchLists}
          style={{ backgroundColor: '#fff' }}
          rowKey="id"
          scroll={{ x: 'max-content' }}
          onChange={({ current }) => {
            setPage(current);
          }}
          pagination={{
            pageSize,
            total,
          }}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                history.push(`/checkin-branch/branch/${record.id}`);
              },
            };
          }}
        />
      </PanelBody>
      {branchId && (
        <BranchActivityListModal
          open={activityListOpen}
          handleClose={() => {
            setBranchId(undefined);
            setActivityListOpen(false);
          }}
          branchId={branchId}
        />
      )}
    </Panel>
  );
};

export default CheckInBranchPage;
